import { useState } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DownloadExcelParams } from "../../store/api/downloadApi";
import dayjs from "dayjs";

type Filters = Record<string, (string | number | boolean)[] | null>;

export const useEmployeeTableFilters = (
  setSearchParams: React.Dispatch<
    React.SetStateAction<DownloadExcelParams & { page_number: number; page_size: number }>
  >
) => {
  const [iikoFilter, setIikoFilter] = useState<string[] | undefined>(undefined);

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Filters
  ) => {
    const filterParams: Partial<DownloadExcelParams> = {};

    // Role filters
    filterParams.oneczup_role_ids = filters.oneczup_role_name?.length
      ? (filters.oneczup_role_name as string[])
      : undefined;

    filterParams.iiko_role_codes = filters.iiko_role_name?.length
      ? (filters.iiko_role_name as string[])
      : undefined;

    // Department filters
    filterParams.oneszup_department_ids = filters.oneczup_department_name?.length
      ? (filters.oneczup_department_name as string[])
      : undefined;

    filterParams.iiko_department_codes = filters.iiko_department_name?.length
      ? (filters.iiko_department_name as string[])
      : undefined;

    filterParams.ispring_department_ids = filters.ispring_department_name?.length
      ? (filters.ispring_department_name as string[])
      : undefined;

    // Date filter
    if (filters.updated_date && Array.isArray(filters.updated_date)) {
      const [start, end] = filters.updated_date as any[];
      filterParams.from_date = start
        ? dayjs(start).startOf("day").format("YYYY-MM-DDTHH:mm:ss")
        : undefined;
      filterParams.to_date = end
        ? dayjs(end).endOf("day").format("YYYY-MM-DDTHH:mm:ss")
        : undefined;
    } else {
      filterParams.from_date = undefined;
      filterParams.to_date = undefined;
    }

    // Generic filters
    Object.entries(filters).forEach(([key, value]) => {
      if (
        ![
          "oneczup_role_name",
          "iiko_role_name",
          "oneczup_department_name",
          "iiko_department_name",
          "ispring_department_name",
          "updated_date",
        ].includes(key)
      ) {
        filterParams[key as keyof DownloadExcelParams] = value?.length
          ? (value[0]?.toString() as any)
          : undefined;
      }
    });

    setIikoFilter(filterParams.iiko_role_codes);

    setSearchParams((prev) => ({
      ...prev,
      page_number: pagination.current!,
      page_size: pagination.pageSize!,
      ...filterParams,
    }));
  };

  return { handleTableChange, iikoFilter };
};
